import { Component, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
@Component({
    selector: 'app-donate',
    templateUrl: './donate.component.html',
    styleUrls: ['./donate.component.scss']
})
export class DonateComponent implements OnInit {
    content = '0x796ab3b52d0f4805bee22b2151426334b8b0828a';
    isCopy = false;
    constructor(private clipboardApi: ClipboardService) { }
    ngOnInit(): void {
    }

    copy() {
        this.clipboardApi.copyFromContent(this.content);
        this.isCopy = true;
        setInterval(() => {
            this.isCopy = false;
        }, 3000)
    }
}
